<template>
  <div class="assess-page">
    <vue-basic-alert :duration="400" :timeout="1000" ref="alert" />

    <!-- Not logged in -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to access the Assessment Tax payment portal.</p>
        <router-link class="login-btn" @click="scrollToTop()" to="/login">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- Logged in -->
    <div v-else class="page-body">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Online Services</p>
            <h1 class="page-title">Assessment Tax Payment</h1>
            <p class="page-subtitle">Pay assessment tax for your registered properties</p>
          </div>
        </div>
        <router-link to="/assessmentpayhistory" class="history-btn" @click="scrollToTop()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Payment History
        </router-link>
      </div>

      <form id="ShopRentForm" novalidate autocomplete="off">

        <!-- Step 1: Select Sabha -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">1</div>
            <div>
              <h2 class="card-title">Select Pradeshiya Sabha</h2>
              <p class="card-desc">Choose the council where your property is registered</p>
            </div>
          </div>
          <div class="field-group">
            <label for="pradeshiya">Pradeshiya Sabha</label>
            <div class="select-wrapper">
              <select @change="AllShopData" class="field-input" name="pradeshiya" id="pradeshiya" v-model="rentObj.pra_sabha">
                <option value="" selected disabled>Choose a Sabha</option>
                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">
                  {{ ps.sb_name_en }} | {{ ps.sb_name_sin }}
                </option>
              </select>
              <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
            </div>
            <p class="field-error" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
          </div>
        </div>

        <!-- Step 2: Search Property -->
        <div id="pay" style="display: none;">
          <div class="form-card">
            <div class="card-header">
              <div class="step-badge">2</div>
              <div>
                <h2 class="card-title">Search Property</h2>
                <p class="card-desc">Filter by location or enter your Form K reference number</p>
              </div>
            </div>

            <!-- Filter Row -->
            <div class="fields-grid four-col">
              <div class="field-group">
                <label for="ward">Ward Number</label>
                <div class="select-wrapper">
                  <select v-model="CatObj.ward" id="ward" class="field-input" @change="SearchByward()" size="5">
                    <option value="" selected disabled>Choose</option>
                    <option v-for="m in savedWards" :key="m.ward_id" :value="m.ward_id">{{ m.ward }}</option>
                  </select>
                  <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
                </div>
                <p class="field-error" v-if="aserrObj.wardErr.length > 0">{{ aserrObj.wardErr[0] }}</p>
              </div>

              <div class="field-group">
                <label for="street">Road / Street</label>
                <div class="select-wrapper">
                  <select v-model="CatObj.street" id="street" class="field-input" @change="SearchByraod()" size="5">
                    <option value="" selected disabled>Choose</option>
                    <option v-for="m in savedStreets" :key="m.street_id" :value="m.street_id">{{ m.street_name }}</option>
                  </select>
                  <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
                </div>
                <p class="field-error" v-if="aserrObj.stretErr.length > 0">{{ aserrObj.stretErr[0] }}</p>
              </div>

              <div class="field-group">
                <label for="cat">Main Category</label>
                <div class="select-wrapper">
                  <select v-model="CatObj.mainc" id="cat" class="field-input" @change="SearchByCat()" size="5">
                    <option value="" selected disabled>Choose</option>
                    <option v-for="m in maincate" :key="m.cat_id" :value="m.cat_id">{{ m.category_name }}</option>
                  </select>
                  <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
                </div>
                <p class="field-error" v-if="aserrObj.maincErr.length > 0">{{ aserrObj.maincErr[0] }}</p>
              </div>

              <div class="field-group">
                <label>Assessment Number</label>
                <div class="select-wrapper">
                  <select v-model="CatObj.assenum" class="field-input" size="5">
                    <option value="" selected disabled>Choose</option>
                    <option v-for="m in propertydetails" :key="m.property_id" :value="m.property_id">{{ m.asses_num }}</option>
                  </select>
                  <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
                </div>
              </div>
            </div>

            <!-- Divider -->
            <div class="section-divider">
              <span>or search directly by Form K Reference</span>
            </div>

            <!-- Direct Search -->
            <div class="fields-grid two-col" style="align-items: flex-end;">
              <div class="field-group">
                <label for="serchprop">Property ID (Form K Reference)</label>
                <input
                  v-model="CatObj.assenum"
                  id="serchprop"
                  list="sabaPropList"
                  class="field-input"
                  placeholder="Type or choose a property ID"
                />
                <datalist id="sabaPropList">
                  <option v-for="p in sabaProp" :key="p.property_id" :value="p.property_id"></option>
                </datalist>
              </div>
              <div class="field-group">
                <button type="button" class="search-btn" @click="populateCustomerDetails()">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                  </svg>
                  Search Property
                </button>
              </div>
            </div>

            <div v-if="msg" class="alert-msg">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              {{ msg }}
            </div>
          </div>

          <!-- Step 3: Property Details & Payment -->
          <template v-for="p in propDetails" :key="p.property_id">

              <!-- Property Info Card -->
              <div class="form-card">
                <div class="card-header">
                  <div class="step-badge">3</div>
                  <div>
                    <h2 class="card-title">Property Details — {{ new Date(this.serverDate).getFullYear() }}</h2>
                    <p class="card-desc">Form K Reference: <strong>{{ CatObj.assenum }}</strong></p>
                  </div>
                </div>

                <div class="fields-grid two-col" style="margin-bottom: 2rem;">
                  <div class="info-field">
                    <span class="info-label">Property Owner(s)</span>
                    <span class="info-value">{{ cusObj.name }}</span>
                  </div>
                  <div class="info-field">
                    <span class="info-label">Property Address</span>
                    <span class="info-value">{{ cusObj.address }}</span>
                  </div>
                </div>

                <!-- Quarter Table -->
                <div class="table-wrapper">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>Quarter</th>
                        <th>Payable Amount</th>
                        <th>Paid Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="quarter-label">First Quarter</td>
                        <td>{{ p.q_one_val }}</td>
                        <td>
                          <span :class="paymentData[p.property_id]?.[1]?.[0] === 'Paid' ? 'badge-paid' : 'badge-unpaid'">
                            {{ paymentData[p.property_id]?.[1] ? paymentData[p.property_id][1][0] : 'Loading...' }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="quarter-label">Second Quarter</td>
                        <td>{{ p.q_two_val }}</td>
                        <td>
                          <span :class="paymentData[p.property_id]?.[2]?.[0] === 'Paid' ? 'badge-paid' : 'badge-unpaid'">
                            {{ paymentData[p.property_id]?.[2] ? paymentData[p.property_id][2][0] : 'Loading...' }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="quarter-label">Third Quarter</td>
                        <td>{{ p.q_three_val }}</td>
                        <td>
                          <span :class="paymentData[p.property_id]?.[3]?.[0] === 'Paid' ? 'badge-paid' : 'badge-unpaid'">
                            {{ paymentData[p.property_id]?.[3] ? paymentData[p.property_id][3][0] : 'Loading...' }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="quarter-label">Fourth Quarter</td>
                        <td>{{ p.q_four_val }}</td>
                        <td>
                          <span :class="paymentData[p.property_id]?.[4]?.[0] === 'Paid' ? 'badge-paid' : 'badge-unpaid'">
                            {{ paymentData[p.property_id]?.[4] ? paymentData[p.property_id][4][0] : 'Loading...' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Payment Card -->
              <div class="form-card">
                <div class="card-header">
                  <div class="step-badge">4</div>
                  <div>
                    <h2 class="card-title">Payment Details</h2>
                    <p class="card-desc">Review your dues and enter the amount to pay</p>
                  </div>
                </div>

                <div class="payment-layout">
                  <!-- Left: Description -->
                  <div class="payment-desc-box">
                    <h4 class="desc-title">Payment Summary</h4>
                    <div class="desc-content" v-html="autodescriptionText"></div>
                    <div class="due-amount-box">
                      <span class="due-label">Total Due for {{ new Date(this.serverDate).getFullYear() }}</span>
                      <span class="due-value">Rs. {{ DueAmount }}</span>
                    </div>
                  </div>

                  <!-- Right: Input Fields -->
                  <div class="payment-inputs">
                    <div class="field-group">
                      <label>Arrears / Excess Amount</label>
                      <div class="input-with-icon">
                        <span class="input-prefix">Rs.</span>
                        <input type="text" class="field-input prefixed" v-model="cusObj.arre" readonly />
                      </div>
                    </div>

                    <div class="field-group">
                      <label for="amountpaidget">Amount Paid</label>
                      <div class="input-with-icon">
                        <span class="input-prefix">Rs.</span>
                        <input id="amountpaidget" type="text" class="field-input prefixed" v-model="paymentAmount" @input="calculatePaymentAllocation" placeholder="0.00" />
                      </div>
                      <p class="field-error" v-if="cusErrObj.amountpaidErr.length > 0">{{ cusErrObj.amountpaidErr[0] }}</p>
                    </div>

                    <div class="field-group" v-if="totalFineAmount > 0">
                      <label>Fine Amount</label>
                      <div class="input-with-icon">
                        <span class="input-prefix fine">Rs.</span>
                        <input type="text" class="field-input prefixed fine-input" v-model="totalFineAmount" readonly />
                      </div>
                    </div>

                    <div class="field-group" v-if="balanceAmount < 0">
                      <label>Balance Forwarded</label>
                      <div class="input-with-icon">
                        <span class="input-prefix success">Rs.</span>
                        <input type="text" class="field-input prefixed success-input" v-model="displayBalanceAmount" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Payment Breakdown -->
              <div v-if="paymentBreakdown.length > 0" class="form-card">
                <div class="card-header">
                  <div class="card-icon-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <div>
                    <h2 class="card-title">Payment Breakdown</h2>
                    <p class="card-desc">Detailed allocation of your payment</p>
                  </div>
                </div>

                <div class="table-wrapper">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th style="text-align:left;">Description</th>
                        <th>Amount</th>
                        <th>Discount</th>
                        <th>Fine</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in paymentBreakdown" :key="index"
                          :class="{
                            'row-reversal': item.type === 'reversal',
                            'row-excess': item.type === 'excess_applied'
                          }">
                        <td style="text-align:left;">{{ item.description }}</td>
                        <td>{{ formatCurrency(item.baseAmount) }}</td>
                        <td>{{ formatCurrency(item.discount) }}</td>
                        <td>{{ formatCurrency(item.fine) }}</td>
                        <td><strong>{{ formatCurrency(item.total) }}</strong></td>
                      </tr>
                      <tr v-if="balanceAmount !== 0" :class="balanceAmount > 0 ? 'row-arrears' : 'row-balance'">
                        <td colspan="4" style="text-align:right;">
                          <strong>{{ balanceAmount > 0 ? 'Remaining Arrears:' : 'Excess / Balance Forward:' }}</strong>
                        </td>
                        <td>
                          <strong :style="{ color: balanceAmount > 0 ? '#c62828' : '#2e7d32' }">
                            {{ balanceAmount > 0 ? '+' : '' }}{{ formatCurrency(displayBalanceAmount) }}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Continue Button -->
              <div class="form-actions">
                <button type="button" class="continue-btn" @click="Continuetoinvoice()">
                  Continue to Invoice
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                  </svg>
                </button>
              </div>

          </template>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueBasicAlert from 'vue-basic-alert';
import { mapMutations, mapState } from "vuex";

export default {
  name: "AssessPIVelg",

  data() {
    return {
      nic: "", sabha: "", userLevel: "",
      rentObj: { pro:"", dis:"", pra_sabha:"", paydes:"", taxNum:"", Payment:"", street:"", ward:"" },
      errorObj: { disErr:[], proErr:[], praErr:[], paydesErr:[], taxNumErr:[], streetErr:[], wardErr:[], PaymentErr:[] },
      CatObj: { ward:"", street:"", mainc:"", propsearch:"", assenum:"" },
      errObj: { wardErr:[], stretErr:[], maincErr:[] },
      aserrObj: { wardErr:[], stretErr:[], maincErr:[] },
      savedWards: [], savedStreets: [],
      itemsPerPage: 10, currentPage: 1,
      maincate: [], sabaProp: [], propertydetails: [],
      showtbl: false, showtblpro: false,
      selectedProperty: null,
      cusObj: { name:"", address:"", headid:"", descr:"", arre:"0.00", finevot:"", arreasvot:"", balancevot:"" },
      cusErrObj: { nameErr:[], addErr:[], headidErr:[], descrErr:[], monthendErr:[], iheadErr:[], fineheadErr:[], arreheadErr:[], amountpaidErr:[], balanceheadErr:[] },
      ownerdetails: [], sabhaIncomeHead: [], propDetails: [],
      paymentData: {}, response: [], responseData: [], allreceipt: [],
      assnum: '', asspropId: 0, usedNum: '', serverDate: '', msg: '', selectedAssesNum: '', p_sabha: [],
      paymentAmount: 0, paymentBreakdown: [], balanceAmount: 0, totalFineAmount: 0,
      descriptionText: '', q1ReverseNeeded: false, q2ReverseNeeded: false, q3ReverseNeeded: false, q4ReverseNeeded: false,
      calArrears: 0, excessAmount: 0, DueAmount: 0, autodescriptionText: '',
      matchUser: undefined,
      assessVote:'', assessArrVote:'', assessFineVote:'', assessExcessVote:'',
      onlinPaydata: [], lastGennum: 0, InvouceNum: '', nextid: 0, theSabhaData: []
    };
  },

  created() {
    this.getSessionData();
    this.AllprSabha();
  },

  computed: {
    ...mapState(["user"]),
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return Array.isArray(this.propertydetails) ? this.propertydetails.slice(startIndex, endIndex) : [];
    },
    totalPages() {
      return Math.ceil(this.propertydetails.length / this.itemsPerPage);
    },
    displayBalanceAmount() {
      return this.roundToTwo(Math.abs(this.balanceAmount)).toFixed(2);
    }
  },

  watch: {
    descriptionText() {}
  },

  methods: {
    ...mapMutations(["setUser"]),

    floorToTwo(value) {
      return Math.floor(parseFloat(value) * 100) / 100;
    },

    // ─────────────────────────────────────────────────────────────────────
    // roundToTwo — uses Math.round on pennies (integer-safe, avoids IEEE 754
    // toFixed drift). Ported from assessPiv so both pages round identically.
    // ─────────────────────────────────────────────────────────────────────
    roundToTwo(value) {
      return Math.round(parseFloat(value) * 100) / 100;
    },

    // ─────────────────────────────────────────────────────────────────────
    // safePercent — integer-safe percentage in pennies. Ported from assessPiv.
    // rate is a whole number (e.g. 5 for 5%, 20 for 20%)
    // ─────────────────────────────────────────────────────────────────────
    safePercent(amount, ratePercent) {
      const pennies = Math.round(parseFloat(amount) * 100);
      const resultPennies = Math.round(pennies * ratePercent / 100);
      return resultPennies / 100;
    },

    async MatchUser(nic) {
      let data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) { this.Nic = data.Unic; this.sabhaCode = data.Usabha; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
      await axios.delete('/deletetasstempbynic/' + this.user.cus_nic);
      await axios.delete('/onlinepaymenttemp/' + this.user.cus_nic);
      try {
        const response = await axios.get('/getserverdate');
        this.serverDate = response.data.serverDate;
      } catch (error) { console.error("Error fetching server date:", error); }
    },

    async AllprSabha() {
      try {
        const allsabhaResponse = await axios.get('/customersabha/' + this.Nic);
        const allsabha = allsabhaResponse.data;
        if (allsabha && allsabha.length > 0) {
          this.p_sabha = [];
          for (const sabha of allsabha) {
            if (sabha.sabha) {
              const psabhaResponse = await axios.get('/PraSabhadata/' + sabha.sabha);
              this.p_sabha.push(...psabhaResponse.data);
            }
          }
        }
      } catch (error) { console.error('Error fetching sabha data:', error); }
    },

    formatCurrency(value) { return this.roundToTwo(value || 0).toFixed(2); },

    // ── Ward / Street name lookups ──────────────────────────────────────────
    getWardName(wardId) {
      const found = this.savedWards.find(w => w.ward_id == wardId);
      return found ? found.ward : wardId;
    },

    getStreetName(streetId) {
      const found = this.savedStreets.find(s => s.street_id == streetId);
      return found ? found.street_name : streetId;
    },

    // ─────────────────────────────────────────────────────────────────────
    // getQuarterCost — ported from assessPiv. Takes availableExcess and
    // applies it to reduce the cash actually needed for the quarter BEFORE
    // computing the overdue fine, so a fine is only charged on the net
    // balance still owed after excess is used — matching assessPiv exactly.
    // ─────────────────────────────────────────────────────────────────────
    getQuarterCost(quarterNum, installment, currentMonth, warrantRate, availableExcess = 0) {
      const starts = [1, 4, 7, 10];
      const ends   = [3, 6, 9, 12];
      const s = starts[quarterNum - 1];
      const e = ends[quarterNum - 1];
      const baseAmount = this.roundToTwo(installment);

      // ── Discount period (payment before quarter starts) ──
      if (currentMonth <= s) {
        const discount   = this.safePercent(baseAmount, 5);
        const grossCost  = this.roundToTwo(baseAmount - discount);
        const excessUsed = this.roundToTwo(Math.min(availableExcess, grossCost));
        const cashNeeded = this.roundToTwo(grossCost - excessUsed);
        return { grossCost, cashNeeded, baseAmount, discount, fine: 0, excessUsed, type: 'discount' };
      }

      // ── Standard period (within quarter) ──
      if (currentMonth > s && currentMonth <= e) {
        const excessUsed = this.roundToTwo(Math.min(availableExcess, baseAmount));
        const cashNeeded = this.roundToTwo(baseAmount - excessUsed);
        return { grossCost: baseAmount, cashNeeded, baseAmount, discount: 0, fine: 0, excessUsed, type: 'standard' };
      }

      // ── Overdue (past quarter end) — excess reduces the base BEFORE the fine is applied ──
      const excessUsed = this.roundToTwo(Math.min(availableExcess, baseAmount));
      const netBase    = this.roundToTwo(baseAmount - excessUsed);
      const fine       = this.safePercent(netBase, this.roundToTwo(warrantRate || 0));
      const grossCost  = this.roundToTwo(netBase + fine);
      return { grossCost, cashNeeded: grossCost, baseAmount, discount: 0, fine, excessUsed, netBase, type: 'fine' };
    },

    // ─────────────────────────────────────────────────────────────────────
    // autoPopulatePaymentAmount — ported from assessPiv. Uses the actual
    // per-quarter values (q_one_val..q_four_val) and applies remaining
    // excess sequentially across unpaid quarters so the preview summary
    // shows "Excess Applied" instead of only listing a discount/fine on
    // the full quarter amount.
    // ─────────────────────────────────────────────────────────────────────
    async autoPopulatePaymentAmount() {
      if (!this.propDetails || !this.propDetails.length) return;
      const property      = this.propDetails[0];
      const tableAreExVal = this.floorToTwo(property.arrears_val || 0);
      const arrears       = this.floorToTwo(this.cusObj.arre || 0);
      const warrantRate   = this.floorToTwo(property.warrant_cost_rate || 20);
      const qVals         = { 1: parseFloat(property.q_one_val)||0, 2: parseFloat(property.q_two_val)||0, 3: parseFloat(property.q_three_val)||0, 4: parseFloat(property.q_four_val)||0 };
      const currentDate   = new Date(this.serverDate);
      const currentMonth  = currentDate.getMonth() + 1;
      const year          = currentDate.getFullYear();

      let desc = '';
      if (tableAreExVal > 0)      desc += `\n Previous Arrears: Rs. ${this.formatCurrency(tableAreExVal)}\n`;
      else if (tableAreExVal < 0) desc += ` Previous Excess: Rs. ${this.formatCurrency(Math.abs(tableAreExVal))}`;
      if (this.calArrears > 0)    desc += `\n Calculated Arrears: Rs. ${this.formatCurrency(this.calArrears)}`;
      if (arrears > 0)            desc += `\n Total Arrears: Rs. ${this.formatCurrency(arrears)}\n`;

      let remainingExcessPreview = (tableAreExVal < 0) ? Math.abs(tableAreExVal) : 0;
      let unpaid = '';
      const unpaidQuarters = [];

      for (let q = 1; q <= 4; q++) {
        const isPaid = this.paymentData[property.property_id]?.[q]?.[0] === 'Paid';
        if (!isPaid) {
          const qc = this.getQuarterCost(q, qVals[q], currentMonth, warrantRate, remainingExcessPreview);
          unpaidQuarters.push(qc);
          remainingExcessPreview = this.floorToTwo(remainingExcessPreview - qc.excessUsed);
          unpaid += ` Quarter ${q}: Rs. ${this.formatCurrency(qc.baseAmount)}`;
          if (qc.discount   > 0) unpaid += ` - Discount: Rs. ${this.formatCurrency(qc.discount)}`;
          if (qc.excessUsed > 0) unpaid += ` - Excess Applied: Rs. ${this.formatCurrency(qc.excessUsed)}`;
          if (qc.fine       > 0) unpaid += ` + Fine: Rs. ${this.formatCurrency(qc.fine)}`;
          unpaid += ` = Rs. ${this.formatCurrency(qc.cashNeeded)}\n`;
        }
      }

      if (unpaid) desc += `\n<b>Unpaid Quarters for ${year}:</b>\n${unpaid}`;
      desc += `\n`;

      const roundedArrears = this.floorToTwo(arrears);
      let totalCashDue = roundedArrears > 0 ? roundedArrears : 0;
      if (unpaidQuarters.length > 0) {
        const netQuarterDue = this.roundToTwo(
          unpaidQuarters.reduce((s, qc) => s + this.roundToTwo(qc.cashNeeded), 0)
        );
        totalCashDue = this.roundToTwo(totalCashDue + netQuarterDue);
      }

      if (totalCashDue < 0) totalCashDue = 0;
      this.paymentAmount = 0;
      this.DueAmount = totalCashDue.toFixed(2);
      this.autodescriptionText = desc;
    },

    // ─────────────────────────────────────────────────────────────────────
    // calculatePaymentAllocation — ported from assessPiv so both pages
    // allocate a payment the same way: previous excess first, then arrears,
    // then annual-in-January logic, then quarter-by-quarter with excess
    // applied inside getQuarterCost.
    // ─────────────────────────────────────────────────────────────────────
    async calculatePaymentAllocation() {
      if (!this.propDetails || !this.propDetails.length) return;
      const property     = this.propDetails[0];
      const payment       = this.floorToTwo(this.paymentAmount || 0);
      const arrears       = this.floorToTwo(this.cusObj.arre || 0);
      const warrantRate   = this.floorToTwo(property.warrant_cost_rate || 20);
      const qVals         = { 1: parseFloat(property.q_one_val)||0, 2: parseFloat(property.q_two_val)||0, 3: parseFloat(property.q_three_val)||0, 4: parseFloat(property.q_four_val)||0 };
      const annualLiability = qVals[1] + qVals[2] + qVals[3] + qVals[4];
      const currentDate   = new Date(this.serverDate);
      const currentMonth  = currentDate.getMonth() + 1;
      const tableAreExVal = this.floorToTwo(property.arrears_val || 0);

      this.paymentBreakdown = []; this.balanceAmount = 0; this.totalFineAmount = 0;
      this.q1ReverseNeeded=false; this.q2ReverseNeeded=false; this.q3ReverseNeeded=false; this.q4ReverseNeeded=false;
      this.excessAmount = 0; this.descriptionText = "";

      let remainingExcess = (tableAreExVal < 0) ? Math.abs(tableAreExVal) : 0;
      this.excessAmount = remainingExcess;
      let rem = payment;

      if (remainingExcess > 0)
        this.paymentBreakdown.push({ description:'Previous Excess Amount', baseAmount:remainingExcess, discount:0, fine:0, total:remainingExcess, type:'excess_applied' });

      if (arrears > 0) {
        const arrearsCleared = Math.min(rem, arrears);
        this.paymentBreakdown.push({ description:'Arrears Payment', baseAmount:arrearsCleared, discount:0, fine:0, total:arrearsCleared, type:'arrears' });
        if (rem < arrears) {
          // Partial arrears payment — remaining arrears become balance
          this.balanceAmount = this.floorToTwo(arrears - rem);
          this.generateDescription();
          return;
        }
        rem = this.roundToTwo(rem - arrears);
        if (rem === 0 && remainingExcess === 0) { this.generateDescription(); return; }
      }

      await this.loadPaymentStatus(property.property_id);
      const isPaid = (q) => this.paymentData[property.property_id]?.[q]?.[0] === 'Paid';
      const q1Paid=isPaid(1), q2Paid=isPaid(2), q3Paid=isPaid(3), q4Paid=isPaid(4);
      const allPaid     = q1Paid && q2Paid && q3Paid && q4Paid;
      const isJan       = currentMonth === 1;
      const annualGross = this.roundToTwo(annualLiability - this.safePercent(annualLiability, 10));
      const totalQPaid  = [1,2,3,4].reduce((s,q) => isPaid(q) ? s + this.roundToTwo(qVals[q] - this.safePercent(qVals[q], 5)) : s, 0);
      const totalAvailForAnnual = this.floorToTwo(totalQPaid + rem + remainingExcess);

      if (isJan && totalAvailForAnnual >= annualGross) {
        const paidQs = [1,2,3,4].filter(q=>isPaid(q)).map(q=>({
          quarter: q,
          paid:    this.roundToTwo(qVals[q] - this.safePercent(qVals[q], 5)),
          discount: this.safePercent(qVals[q], 5)
        }));
        if (paidQs.length > 0 && paidQs.length < 4) {
          paidQs.forEach(q => { this.paymentBreakdown.push({ description:`Quarter ${q.quarter} (Reversed)`, baseAmount:-qVals[q.quarter], discount:-q.discount, fine:0, total:-q.paid, type:'reversal', quarter:q.quarter }); });
          this.q1ReverseNeeded=q1Paid; this.q2ReverseNeeded=q2Paid; this.q3ReverseNeeded=q3Paid; this.q4ReverseNeeded=q4Paid;
        }
        const annualDiscount = this.safePercent(annualLiability, 10);
        this.paymentBreakdown.push({ description:'Annual Payment', baseAmount:annualLiability, discount:annualDiscount, fine:0, total:annualGross, type:'annual' });
        this.balanceAmount = -this.roundToTwo(totalAvailForAnnual - annualGross);
        this.generateDescription(); return;
      }

      // ── All quarters already paid — any payment is excess ──
      if (allPaid) {
        this.paymentBreakdown.push({ description:'Excess Payment', baseAmount:payment, discount:0, fine:0, total:payment, type:'excess_payment' });
        this.balanceAmount = -(this.roundToTwo(payment + remainingExcess));
        this.generateDescription(); return;
      }

      const anyUnpaid = [1,2,3,4].some(q => !isPaid(q));
      if (!anyUnpaid && rem > 0) {
        this.paymentBreakdown.push({ description:'Excess Payment', baseAmount:rem, discount:0, fine:0, total:rem, type:'excess_payment' });
        this.balanceAmount = -(this.roundToTwo(rem + remainingExcess));
        this.generateDescription(); return;
      }

      for (let q = 1; q <= 4; q++) {
        if (isPaid(q)) continue;
        if (rem <= 0 && remainingExcess <= 0) break;
        const qc = this.getQuarterCost(q, qVals[q], currentMonth, warrantRate, remainingExcess);
        if (rem >= qc.cashNeeded) {
          this.paymentBreakdown.push({ description:`Quarter ${q}`, baseAmount:qc.baseAmount, discount:qc.discount, fine:qc.fine, excessUsed:qc.excessUsed, total:qc.grossCost, netCash:qc.cashNeeded, type:'quarter', quarter:q });
          this.totalFineAmount = this.roundToTwo(this.totalFineAmount + qc.fine);
          rem             = this.roundToTwo(rem - qc.cashNeeded);
          remainingExcess = this.roundToTwo(remainingExcess - qc.excessUsed);
        } else {
          this.balanceAmount = -this.roundToTwo(rem + remainingExcess);
          rem = 0; remainingExcess = 0; break;
        }
      }

      const leftover = this.roundToTwo(rem + remainingExcess);
      if (leftover > 0) this.balanceAmount = -leftover;
      this.generateDescription();
    },

    // ─────────────────────────────────────────────────────────────────────
    // generateDescription — ported from assessPiv, uses netCash for the
    // "Paid Amount" shown per quarter so it reflects excess applied.
    // ─────────────────────────────────────────────────────────────────────
    generateDescription() {
      const year = this.serverDate ? new Date(this.serverDate).getFullYear() : "";
      let d = `For Year: ${year}   Ass Num: ${this.assnum}   PID: ${this.asspropId}   Used Num: ${this.usedNum}\n`;
      const ia = this.floorToTwo(this.calArrears);
      if (ia > 0) d += `Arrears Calculated: ${this.formatCurrency(ia)}\n`;
      else if (ia < 0) d += `Initial Excess: ${this.formatCurrency(ia)}\n`;
      this.paymentBreakdown.forEach(item => {
        if      (item.type==='arrears')        d += `- ${item.description}: ${this.formatCurrency(item.total)}\n`;
        else if (item.type==='excess_applied') d += `- ${item.description}: ${this.formatCurrency(item.total)}\n`;
        else if (item.type==='excess_payment') d += `- ${item.description}: ${this.formatCurrency(item.total)}\n`;
        else if (item.type==='reversal')       d += `- ${item.description}\n  Reversed Amount: ${this.formatCurrency(Math.abs(item.total))}\n`;
        else if (item.type==='annual')         d += `- ${item.description}; Annual Value: ${this.formatCurrency(item.baseAmount)}; Discount (10%): ${this.formatCurrency(item.discount)}; Paid Amount: ${this.formatCurrency(item.total)};\n`;
        else if (item.type==='quarter') {
          d += `- ${item.description}; Amount to Pay: ${this.formatCurrency(item.baseAmount)};`;
          if (item.discount   > 0) d += ` Discount (5%): ${this.formatCurrency(item.discount)};`;
          if (item.excessUsed > 0) d += ` Excess Applied: ${this.formatCurrency(item.excessUsed)};`;
          if (item.fine       > 0) d += ` Fine: ${this.formatCurrency(item.fine)};`;
          d += ` Paid Amount: ${this.formatCurrency(item.netCash)};\n`;
        }
      });
      if (this.totalFineAmount > 0) d += `- Total Fines: ${this.formatCurrency(this.totalFineAmount)}\n`;
      if (this.balanceAmount !== 0) {
        if (this.balanceAmount > 0) d += `- Remaining Arrears: +${this.formatCurrency(this.displayBalanceAmount)}`;
        else                        d += `- Excess/Balance Forward: ${this.formatCurrency(this.displayBalanceAmount)}`;
      }
      this.descriptionText = d;
    },

    async AllShopData() {
      this.sabha          = this.rentObj.pra_sabha;
      this.CatObj.assenum = "";
      this.propDetails    = [];
      this.showtblpro     = false;
      document.getElementById('pay').style.display = 'block';
      this.maincate    = (await axios.get('/maincat/')).data;
      this.savedWards  = (await axios.get('/wdbys/' + this.rentObj.pra_sabha)).data;
      this.savedStreets = (await axios.get('/stbys/' + this.rentObj.pra_sabha)).data;
      try {
        this.sabaProp        = (await axios.get('/props/' + this.rentObj.pra_sabha)).data;
        this.propertydetails = (await axios.get('/props/' + this.rentObj.pra_sabha)).data;
      } catch (error) { console.error("Error fetching data", error); }
      this.theSabhaData     = (await axios.get('/PraSabhadata/' + this.rentObj.pra_sabha)).data;
      this.assessVote       = this.theSabhaData[0].assess_vote;
      this.assessArrVote    = this.theSabhaData[0].assess_arrears_vote;
      this.assessFineVote   = this.theSabhaData[0].assess_fine_vote;
      this.assessExcessVote = this.theSabhaData[0].assess_excess_vote;
    },

    async SearchByward() {
      const response = await axios.get(`/wardproplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}`);
      this.propertydetails = response.data;
    },

    async SearchByraod() {
      const response = await axios.get(`/streetproplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}/${this.CatObj.street}`);
      this.propertydetails = response.data;
    },

    async SearchByCat() {
      this.checkFormas();
      if (!this.checkEmptyErrasnn()) { this.$refs.alert.showAlert('error', 'Fill Required Field!'); return; }
      const response = await axios.get(`/proplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}/${this.CatObj.street}/${this.CatObj.mainc}`);
      this.propertydetails = response.data;
    },

    async loadPaymentStatus(pid) {
      const currentYear = new Date(this.serverDate).getFullYear();
  try {
  const Propresponse = await axios.get(`/sabapropid/${this.sabha}/${pid}`);
  const propData = Propresponse.data;
  if (!this.paymentData[pid]) this.paymentData = { ...this.paymentData, [pid]: {} };

  const lastPayQ = Number(propData?.[0]?.last_paid_quarter || 0);
  const lastPayY = Number(propData?.[0]?.last_paid_year || 0);

  for (let quarter = 1; quarter <= 4; quarter++) {
    const isPaid = lastPayY === currentYear && quarter <= lastPayQ;
    this.paymentData[pid] = {
      ...this.paymentData[pid],
      [quarter]: isPaid ? ["Paid", "0.00"] : ["Not Paid", "Not Paid"]
    };
  }

  return this.paymentData[pid];
} catch {
  if (!this.paymentData[pid]) this.paymentData[pid] = {};
  for (let q = 1; q <= 4; q++) this.paymentData[pid] = { ...this.paymentData[pid], [q]: ["Error", "Error"] };
  return this.paymentData[pid];
}
    },
    //   try {
    //     const Propresponse = await axios.get(`/sabapropid/${this.sabha}/${pid}`);
    //     const propData = Propresponse.data;
    //     if (!this.paymentData[pid]) this.paymentData = { ...this.paymentData, [pid]: {} };
    //     const annualResponse = await axios.get(`/pqpayview/${pid}/${this.sabha}/5/${currentYear}`);
    //     if (annualResponse.data?.[0]) {
    //       for (let q = 1; q <= 4; q++) this.paymentData[pid] = { ...this.paymentData[pid], [q]: ["Paid", "0.00"] };
    //       return this.paymentData[pid];
    //     }
    //     // for (let quarter = 1; quarter <= 4; quarter++) {
    //     //   try {
    //     //     const response = await axios.get(`/pqpayview/${pid}/${this.sabha}/${quarter}/${currentYear}`);
    //     //     const result   = response.data?.[0];
    //     //     this.paymentData[pid] = { ...this.paymentData[pid], [quarter]: result?.paid_amount ? ["Paid", this.floorToTwo(result.fine_amount || 0).toFixed(2)] : ["Not Paid", "Not Paid"] };
    //     //   } catch { this.paymentData[pid] = { ...this.paymentData[pid], [quarter]: ["Error", "Error"] }; }
    //     // }
    //     const allNotPaid = Object.values(this.paymentData[pid]).every(q => q[0] === "Not Paid" || q[0] === "Error");
    //     if (allNotPaid && propData?.[0]) {
    //       const lastPayQ = Number(propData[0].last_paid_quarter || 0);
    //       const lastPayY = Number(propData[0].last_paid_year   || 0);
    //       if (lastPayQ > 0 && lastPayQ <= 4 && lastPayY === currentYear) {
    //         for (let quarter = 1; quarter <= 4; quarter++) {
    //           this.paymentData[pid] = { ...this.paymentData[pid], [quarter]: quarter <= lastPayQ ? ["Paid", "0.00"] : ["Not Paid", "Not Paid"] };
    //         }
    //       }
    //     }
    //     return this.paymentData[pid];
    //   } catch {
    //     if (!this.paymentData[pid]) this.paymentData[pid] = {};
    //     for (let q = 1; q <= 4; q++) this.paymentData[pid] = { ...this.paymentData[pid], [q]: ["Error", "Error"] };
    //     return this.paymentData[pid];
    //   }
    // },

    async calculateArrears(property) {
      try {
        const response = await axios.get(`/sabapropid/${this.sabha}/${property}`);
        const prop = response.data;
        if (!prop || prop.length === 0) return;
        const availableArrears = this.floorToTwo(prop[0].arrears_val) || 0;
        const currentYear  = new Date(this.serverDate).getFullYear();
        const lastPayQua   = parseInt(prop[0].last_paid_quarter) || 0;
        const lastPayYear  = parseInt(prop[0].last_paid_year)    || 0;
        const fq  = this.floorToTwo(prop[0].q_one_val)   || 0;
        const sq  = this.floorToTwo(prop[0].q_two_val)   || 0;
        const tq  = this.floorToTwo(prop[0].q_three_val) || 0;
        const foq = this.floorToTwo(prop[0].q_four_val)  || 0;
        const wc  = (this.floorToTwo(prop[0].warrant_cost_rate) || 0) / 100;
        let lastarr = 0;
        if (lastPayYear < currentYear && lastPayYear > 0) {
          if (lastPayQua === 1)      lastarr += (sq + sq * wc) + (tq + tq * wc) + (foq + foq * wc);
          else if (lastPayQua === 2) lastarr += (tq + tq * wc) + (foq + foq * wc);
          else if (lastPayQua === 3) lastarr += (foq + foq * wc);
          const fullUnpaidYears = currentYear - lastPayYear - 1;
          if (fullUnpaidYears > 0) {
            const oneYear = (fq + fq * wc) + (sq + sq * wc) + (tq + tq * wc) + (foq + foq * wc);
            lastarr += fullUnpaidYears * oneYear;
          }
        }
        this.cusObj.arre = this.floorToTwo(availableArrears + lastarr).toFixed(2);
        this.calArrears  = this.floorToTwo(lastarr);
      } catch (error) { console.error("Error calculating arrears:", error); }
    },

    async populateCustomerDetails() {
      const property  = this.CatObj.assenum;
      await axios.delete('/onlinepaymenttemp/' + property);

      this.sabha      = this.rentObj.pra_sabha;
      this.msg        = '';
      this.descriptionText  = "";
      this.paymentBreakdown = [];
      await this.calculateArrears(property);
      await this.loadPaymentStatus(property);
      try {
        const response = await axios.get(`/prownerdetails/${property}/${this.sabha}`);
        if (response.data && response.data.length > 0) {
          this.ownerdetails    = response.data;
          this.cusObj.name     = this.ownerdetails.map(o => o.cus_name).join(', ') || "";
          this.cusObj.address  = this.ownerdetails[0].prop_address || "";
          this.assnum          = this.ownerdetails[0].asses_num;
          this.asspropId       = this.ownerdetails[0].property_id;
        } else {
          this.$refs.alert.showAlert('error', 'No owner details found');
          return;
        }
        this.propDetails = (await axios.get(`/sabapropid/${this.sabha}/${property}`)).data;
        this.usedNum     = this.propDetails[0].used_num;

        // ✅ Fix: set selectedProperty so the guard check passes
        this.selectedProperty = property;

        const currentYear = new Date(this.serverDate).getFullYear();
        const lastPayQua  = parseInt(this.propDetails[0].last_paid_quarter) || 0;
        const lastPayY    = parseInt(this.propDetails[0].last_paid_year)    || 0;
        if (lastPayQua > 0 && lastPayQua <= 4 && lastPayY > currentYear) {
          this.msg        = `This property is already paid up to ${this.getQuarterName(lastPayQua)} of year ${lastPayY}.`;
          this.showtblpro = false;
        } else {
          this.showtblpro = true;
          await this.autoPopulatePaymentAmount();
        }
        this.balanceAmount   = 0;
        this.q1ReverseNeeded = this.q2ReverseNeeded = this.q3ReverseNeeded = this.q4ReverseNeeded = false;
      } catch (error) { console.error("Error fetching owner details:", error); }
    },

    getQuarterName(q) { return { 1:"1st Quarter", 2:"2nd Quarter", 3:"3rd Quarter", 4:"4th Quarter" }[q] || `Quarter ${q}`; },

    formattedDate() {
      let date = new Date(this.serverDate);
      return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
    },

    checkFormas() {
      this.aserrObj.wardErr = []; this.aserrObj.stretErr = []; this.aserrObj.maincErr = [];
      if (!this.CatObj.ward)  this.aserrObj.wardErr.push("required");
      if (!this.CatObj.street) this.aserrObj.stretErr.push("required");
      if (!this.CatObj.mainc) this.aserrObj.maincErr.push("required");
    },

    checkEmptyErrasnn() {
      for (var typeErr in this.aserrObj) { if (this.aserrObj[typeErr].length !== 0) return false; }
      return true;
    },

    scrollToTop() { window.scrollTo(0, 0); },

    // ── Validation ──────────────────────────────────────────────────────
    resetCheckErr2() {
      this.cusErrObj.fineheadErr   = [];
      this.cusErrObj.descrErr      = [];
      this.cusErrObj.iheadErr      = [];
      this.cusErrObj.arreheadErr   = [];
      this.cusErrObj.amountpaidErr = [];
      this.cusErrObj.balanceheadErr = [];
    },

    checkEmptyErr2() {
      for (var typeErr in this.cusErrObj) {
        if (this.cusErrObj[typeErr].length !== 0) return false;
      }
      return true;
    },

    checkForm2() {
      this.resetCheckErr2();
      if (this.totalFineAmount > 0 && !this.cusObj.finevot) {
        this.cusErrObj.fineheadErr.push("required.");
      }
      if (!this.cusObj.headid && parseFloat(this.paymentAmount) > parseFloat(this.cusObj.arre)) {
        this.cusErrObj.iheadErr.push("required");
      }
      if (!this.cusObj.arreasvot && parseFloat(this.cusObj.arre) > 0) {
        this.cusErrObj.arreheadErr.push("required");
      }
      if (!this.paymentAmount || parseFloat(this.paymentAmount) <= 0) {
        this.cusErrObj.amountpaidErr.push("required");
      }
      if (this.balanceAmount < 0 && !this.cusObj.balancevot) {
        this.cusErrObj.balanceheadErr.push("required");
      }
    },

    // ── Main submit ─────────────────────────────────────────────────────────
    // BUG FIX: receipt amounts now read directly off the paymentBreakdown
    // items produced by the ported calculatePaymentAllocation (netCash /
    // excessUsed / total), instead of back-deriving totals from
    // this.paymentAmount minus discount/arrears/balance — which is what
    // produced the wrong "no excess applied" summary before.
    async Continuetoinvoice() {
      if (!this.ownerdetails || this.ownerdetails.length === 0) {
        this.$refs.alert.showAlert('error', 'Please select a property first');
        return;
      }

      let arramount           = 0;
      let totalPaidAmount     = 0;
      let quarterTotalDiscount = 0;

      const propertyId = this.ownerdetails[0]?.property_id;
const praSabha = this.rentObj?.pra_sabha;   

const checkRes = await axios.get(`/getpaytemp/${propertyId}/${praSabha}`);


if (checkRes.data.length > 0) {
  await axios.delete(`/delalltempquatpay/${propertyId}/${praSabha}`);
}
axios.delete(`/delexcess/${propertyId}/${this.sabha}`);

      try {
        const currentDate  = new Date(this.serverDate);
        const paymentmonth = currentDate.getMonth() + 1;
        const paymentyear  = currentDate.getFullYear();

        this.onlinPaydata = (await axios.get('/genarateinvonline/' + this.rentObj.pra_sabha)).data;
        this.lastGennum   = parseInt(this.onlinPaydata[0].gen_num);

        this.InvouceNum = this.rentObj.pra_sabha.concat(paymentmonth, paymentyear, this.lastGennum);
        this.nextid     = this.lastGennum + 1;

        const genInvNum = { gen_num: this.nextid };
        await axios.put('/updateinvonline/' + this.rentObj.pra_sabha, genInvNum);

        let arrearsAmount        = 0;
        let excessAppliedAmount  = 0;
        let quarterPayments      = [];
        let excessPayment        = null;

        this.paymentBreakdown.forEach(item => {
          if (item.type === 'reversal')       return;
          if (item.type === 'arrears')        arrearsAmount = this.floorToTwo(item.total);
          if (item.type === 'excess_applied') excessAppliedAmount = this.floorToTwo(item.total);
          if (item.type === 'quarter' || item.type === 'annual') quarterPayments.push(item);
          if (item.type === 'excess_payment') excessPayment = item;
        });

        // ── Arrears Receipt ───────────────────────────────────────────────
        let quarterDescription = '';
        let reverseneed = 0;
        const year = paymentyear;
        let arrearsDescription = '';

        quarterDescription += `For Year: ${year}; `;
        quarterDescription += `Ass Num: ${this.assnum},   `;
        quarterDescription += `PID: ${this.asspropId},   Used Num: ${this.usedNum}\n`;

        if (this.q1ReverseNeeded) { quarterDescription += `Quater 1 Paid\n`; reverseneed = 1; }
        if (this.q2ReverseNeeded) { quarterDescription += `Quater 2 Paid\n`; reverseneed = 1; }
        if (this.q3ReverseNeeded) { quarterDescription += `Quater 3 Paid\n`; reverseneed = 1; }
        if (this.q4ReverseNeeded) { quarterDescription += `Quater 4 Paid\n`; reverseneed = 1; }

        if (arrearsAmount > 0) {
          // arrearsAmount is already min(payment, arrears) from calculatePaymentAllocation
          arramount = arrearsAmount;
          arrearsDescription += `Ass Num: ${this.assnum},   PID: ${this.asspropId},   Used Num: ${this.usedNum}\nArrears Payment`;
          if (this.balanceAmount > 0) {
            arrearsDescription += `\nRemaining Arrears: ${this.formatCurrency(this.balanceAmount)}\n`;
          }

          const arrearsReceiptData = {
            invoice_num:      this.InvouceNum,
            sabha:            this.sabha,
            cus_nic:          this.ownerdetails[0]?.property_id?.toString() || "",
            cus_name:         this.cusObj.name || "",
            cus_contact:      this.ownerdetails[0]?.cus_contact?.toString() || "",
            cus_address:      this.cusObj.address || "",
            sb_rate_head:     this.assessArrVote,
            description:      arrearsDescription,
            amount:           this.floorToTwo(arramount),
            stamp:            "0.00",
            discount:         "0.00",
            shoptotalarrears: "0.00",
            paymonth:         `${paymentmonth}-${paymentyear}`,
            vat:              "0.00",
            shopdid:          this.ownerdetails[0]?.property_id?.toString() || "0",
            date:             this.formattedDate(),
            sub_nic:          this.nic,
          };
          await axios.post("/assreceipttemp/", arrearsReceiptData);
        }

        // ── Quarter / Annual Receipt ──────────────────────────────────────
        if (quarterPayments.length > 0) {
          quarterTotalDiscount = this.roundToTwo(
            quarterPayments.reduce((sum, item) => sum + this.floorToTwo(item.discount || 0), 0)
          );
          // totalPaidAmount = actual cash applied to quarters (netCash already
          // has excess/discount factored in), matching assessPiv's addToTemp.
          totalPaidAmount = this.roundToTwo(
            quarterPayments.reduce((sum, item) => sum + this.floorToTwo(item.netCash ?? item.total), 0)
          );

          if (excessAppliedAmount > 0) {
            quarterDescription += `Previous Excess Amount: ${this.formatCurrency(excessAppliedAmount)}\n`;
          }

          quarterPayments.forEach(item => {
            if (item.type === 'annual') {
              quarterDescription += `- ${item.description};`;
              quarterDescription += `  Annual Value: ${this.formatCurrency(item.baseAmount)};`;
              quarterDescription += `  Discount (10%): ${this.formatCurrency(item.discount)};`;
              quarterDescription += `  Paid Amount: ${this.formatCurrency(item.total)};`;
            } else if (item.type === 'quarter') {
              quarterDescription += `- ${item.description}`;
              quarterDescription += ` Amount to Paid: ${this.formatCurrency(item.baseAmount)}; `;
              if (item.discount   > 0) quarterDescription += ` Discount (5%): ${this.formatCurrency(item.discount)}; `;
              if (item.excessUsed > 0) quarterDescription += ` Excess Applied: ${this.formatCurrency(item.excessUsed)}; `;
              if (item.fine       > 0) quarterDescription += ` Fine: ${this.formatCurrency(item.fine)}; `;
              quarterDescription += ` Paid Amount: ${this.formatCurrency(item.netCash ?? item.total)}; `;
            }
            quarterDescription += `\n`;
          });

          if (this.balanceAmount > 0) {
            quarterDescription += `Remaining Arrears: +${this.formatCurrency(this.balanceAmount)}\n`;
          }

          const quarterReceiptData = {
            invoice_num:      this.InvouceNum,
            sabha:            this.sabha,
            cus_nic:          this.ownerdetails[0]?.property_id?.toString() || "",
            cus_name:         this.cusObj.name || "",
            cus_contact:      this.ownerdetails[0]?.cus_contact?.toString() || "",
            cus_address:      this.cusObj.address || "",
            sb_rate_head:     this.assessVote,
            description:      quarterDescription,
            amount:           totalPaidAmount.toFixed(2),
            stamp:            "0.00",
            discount:         quarterTotalDiscount.toFixed(2),
            shoptotalarrears: "0.00",
            paymonth:         `${paymentmonth}-${paymentyear}`,
            vat:              "0.00",
            shopdid:          this.ownerdetails[0]?.property_id?.toString() || "0",
            date:             this.formattedDate(),
            sub_nic:          this.nic,
          };
          await axios.post("/assreceipttemp/", quarterReceiptData);

          for (const item of quarterPayments) {
            const tempPaydata = {
              sb_code:        this.sabha,
              property_id:    this.ownerdetails[0]?.property_id?.toString() || "",
              quarter_num:    item.type === 'annual' ? '5' : item.quarter?.toString(),
              paid_amount:    this.floorToTwo(item.netCash ?? item.total).toFixed(2),
              paid_date:      this.formattedDate(),
              discount_given: this.floorToTwo(item.discount).toFixed(2),
              paid_year:      paymentyear.toString(),
              fine_amount:    this.floorToTwo(item.fine || 0).toFixed(2),
              record_date:    this.formattedDate(),
              reverse_needed: reverseneed,
            };
            await axios.post("/savpaytemp/", tempPaydata);
          }
        }

        // ── Excess Payment Receipt ────────────────────────────────────────
        if (excessPayment) {
          let excessDescription  = `For Year: ${year}   `;
          excessDescription     += `Ass Num: ${this.assnum}   `;
          excessDescription     += `PID: ${this.asspropId}   `;
          excessDescription     += `Used Num: ${this.usedNum}\n`;
          if (excessAppliedAmount > 0) excessDescription += `Previous Excess Amount: ${this.formatCurrency(excessAppliedAmount)}\n`;
          excessDescription += `Excess Amount: ${this.formatCurrency(excessPayment.total)}\n`;
          excessDescription += `Total Excess/Balance Forward: ${this.formatCurrency(Math.abs(this.balanceAmount))}`;

          const excessReceiptData = {
            invoice_num:      this.InvouceNum,
            sabha:            this.sabha,
            cus_nic:          this.ownerdetails[0]?.property_id?.toString() || "",
            cus_name:         this.cusObj.name || "",
            cus_contact:      this.ownerdetails[0]?.cus_contact?.toString() || "",
            cus_address:      this.cusObj.address || "",
            sb_rate_head:     this.assessExcessVote,
            description:      excessDescription,
            amount:           this.floorToTwo(excessPayment.total).toFixed(2),
            stamp:            "0.00",
            discount:         "0.00",
            shoptotalarrears: "0.00",
            paymonth:         `${paymentmonth}-${paymentyear}`,
            vat:              "0.00",
            shopdid:          this.ownerdetails[0]?.property_id?.toString() || "0",
            date:             this.formattedDate(),
            sub_nic:          this.nic,
          };
          await axios.post("/assreceipttemp/", excessReceiptData);
        }

        // ── Fine Receipt ──────────────────────────────────────────────────
        if (this.totalFineAmount > 0) {
          const fineDescription = `Ass Num: ${this.assnum},   PID: ${this.asspropId},   Used Num: ${this.usedNum}\nFine Amount`;
          const fineReceiptData = {
            invoice_num:      this.InvouceNum,
            sabha:            this.sabha,
            cus_nic:          this.ownerdetails[0]?.property_id?.toString() || "",
            cus_name:         this.cusObj.name || "",
            cus_contact:      this.ownerdetails[0]?.cus_contact?.toString() || "",
            cus_address:      this.cusObj.address || "",
            sb_rate_head:     this.assessFineVote,
            description:      fineDescription,
            amount:           this.floorToTwo(this.totalFineAmount).toFixed(2),
            stamp:            "0.00",
            discount:         "0.00",
            shoptotalarrears: "0.00",
            paymonth:         `${paymentmonth}-${paymentyear}`,
            vat:              "0.00",
            shopdid:          this.ownerdetails[0]?.property_id?.toString() || "0",
            date:             this.formattedDate(),
            sub_nic:          this.nic,
          };
          await axios.post("/assreceipttemp/", fineReceiptData);
        }

        // ── Balance/Excess Forward Receipt ────────────────────────────────
        if (this.balanceAmount < 0) {
          const excessAmountBalance = this.roundToTwo(Math.abs(this.balanceAmount));
          const balanceDescription  = `Ass Num: ${this.assnum} ,  PID: ${this.asspropId},   Used Num: ${this.usedNum}\nBalance Forwarded`;
          const balanceReceiptData  = {
            invoice_num:      this.InvouceNum,
            sabha:            this.sabha,
            cus_nic:          this.ownerdetails[0]?.property_id?.toString() || "",
            cus_name:         this.cusObj.name || "",
            cus_contact:      this.ownerdetails[0]?.cus_contact?.toString() || "",
            cus_address:      this.cusObj.address || "",
            sb_rate_head:     this.assessExcessVote,
            description:      balanceDescription,
            amount:           excessAmountBalance.toFixed(2),
            stamp:            "0.00",
            discount:         "0.00",
            shoptotalarrears: "0.00",
            paymonth:         `${paymentmonth}-${paymentyear}`,
            vat:              "0.00",
            shopdid:          this.ownerdetails[0]?.property_id?.toString() || "0",
            date:             this.formattedDate(),
            sub_nic:          this.nic,
          };
          await axios.post("/assreceipttemp/", balanceReceiptData);
        }

        // ── Save Balance ──────────────────────────────────────────────────
        if (this.balanceAmount !== 0) {
          const balanceData = {
            property_id: this.ownerdetails[0]?.property_id?.toString() || "",
            sabha_code:  this.sabha,
            amount:      this.roundToTwo(this.balanceAmount).toFixed(2),
          };
          await axios.post("/savexcess/", balanceData);
        }

        // ── Online Payment Temp ───────────────────────────────────────────
        const onlineData = {
          online_cus_nic:     this.ownerdetails[0]?.property_id || "",
          online_sabha_code:  this.sabha,
          online_invoice_num: this.InvouceNum,
          online_pay_amount:  this.floorToTwo(this.paymentAmount),
          online_pay_month:   paymentmonth,
          online_pay_year:    paymentyear,
          online_pay_des:     this.descriptionText,
          pay_type:           "assessmenttax",
          vote:               "assessmenttax",
          online_pay_date:    this.formattedDate()
        };
        await axios.post("/onlinepaymenttemp/", onlineData);

        // ── Bill Data ─────────────────────────────────────────────────────
        const billdata = {
          invoice_num:    this.InvouceNum,
          sabha:          this.sabha,
          property_id:    this.ownerdetails[0]?.property_id || "",
          ward:           this.getWardName(this.CatObj.ward),
          street:         this.getStreetName(this.CatObj.street),
          assess_number:  this.assnum,
          used_number:    this.usedNum,
          cus_name:       this.cusObj.name,
          cus_contact:    this.ownerdetails[0]?.cus_contact || "",
          cus_address:    this.cusObj.address,
          description:    this.descriptionText,
          excess_arrears: this.floorToTwo(this.balanceAmount),
          quater_amount:  this.floorToTwo(totalPaidAmount),
          fine:           this.totalFineAmount,
          discount:       quarterTotalDiscount,
          paid_amount:    this.floorToTwo(this.paymentAmount),
          paymonth:       `${paymentmonth}-${paymentyear}`,
          sub_nic:        this.user.cus_nic,
        };
        await axios.post("/assreceiptbilltemp/", billdata);

        // ── Session Data & Navigate ───────────────────────────────────────
        const sesdata = {
          invoice_num:    this.InvouceNum,
          sabha_code:     this.sabha,
          property_id:    this.ownerdetails[0]?.property_id || "",
          ward:           this.getWardName(this.CatObj.ward),
          street:         this.getStreetName(this.CatObj.street),
          assess_number:  this.assnum,
          used_number:    this.usedNum,
          cus_name:       this.cusObj.name,
          cus_contact:    this.ownerdetails[0]?.cus_contact || "",
          cus_address:    this.cusObj.address,
          remark:         this.descriptionText,
          excess_arrears: this.floorToTwo(arramount),
          quater_amount:  this.floorToTwo(totalPaidAmount),
          fine:           this.totalFineAmount,
          discount:       quarterTotalDiscount,
          balanceAmount:  this.floorToTwo(this.balanceAmount),
          paid_amount:    this.floorToTwo(this.paymentAmount),
          paymonth:       `${paymentmonth}-${paymentyear}`,
          sub_nic:        this.user.cus_nic,
        };
        sessionStorage.setItem('taxDetails', JSON.stringify(sesdata));
        this.$router.push("/assessmenttaxinvoice");

        // ── Reset state ───────────────────────────────────────────────────
        this.selectedProperty  = null;
        this.paymentAmount     = 0;
        this.paymentBreakdown  = [];
        this.balanceAmount     = 0;
        this.q1ReverseNeeded   = false;
        this.q2ReverseNeeded   = false;
        this.q3ReverseNeeded   = false;
        this.q4ReverseNeeded   = false;
        this.cusObj = { name:"", address:"", headid:"", descr:"", arre:"0.00", finevot:"", arreasvot:"" };
        this.descriptionText   = "";

      } catch (error) {
        console.error("Error during API calls:", error);
        let errorMsg = 'An error occurred while processing.';
        if (error.response)      errorMsg += ` Server: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`;
        else if (error.request)  errorMsg += ' No response from server.';
        else                     errorMsg += ` ${error.message}`;
        this.$refs.alert.showAlert('error', errorMsg);
      }
    },

  }, // ← end of methods

  components: { VueBasicAlert }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.assess-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}

.page-body,
form#ShopRentForm {
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}

/* ── Login Prompt ── */
.login-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}
.login-card {
  background: #fff;
  border-radius: 1.4rem;
  padding: 4rem 3.5rem;
  text-align: center;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p { font-size: 1.45rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1.1rem 2.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.5rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.8rem; gap: 1.5rem; flex-wrap: wrap;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.4rem; color: #7a6258; margin: 0; }

.history-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.9rem 1.8rem;
  border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff;
  border-radius: 0.8rem; font-size: 1.4rem; font-weight: 500;
  text-decoration: none; transition: all 0.2s; white-space: nowrap;
}
.history-btn svg { width: 1.7rem; height: 1.7rem; }
.history-btn:hover { background: #c2440a; color: #fff; }

/* ── Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.4rem;
  margin-bottom: 1.6rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  transition: box-shadow 0.2s;
}
.form-card:hover { box-shadow: 0 4px 18px rgba(100,50,30,0.1); }

.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem;
  border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; font-size: 1.6rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.card-icon-sm {
  width: 4rem; height: 4rem; border-radius: 0.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.card-icon-sm svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Fields ── */
.fields-grid { display: grid; gap: 1.6rem 2rem; }
.four-col { grid-template-columns: repeat(4, 1fr); }
.two-col { grid-template-columns: repeat(2, 1fr); }

.field-group { display: flex; flex-direction: column; gap: 0.5rem; }
.field-group label { font-size: 1.3rem; font-weight: 500; color: #4a3028; }

.field-input {
  width: 100%; padding: 1rem 1.3rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; color: #1c0f0a;
  background: #faf8f6; border: 1.5px solid #ddd4ca; border-radius: 0.7rem;
  outline: none; appearance: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.field-input:focus { border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.1); }
.field-input::placeholder { color: #bfb0a5; }
.field-input[readonly] { opacity: 0.75; cursor: default; }

.select-wrapper { position: relative; }
.select-wrapper .field-input { padding-right: 3.5rem; cursor: pointer; }
.select-arrow {
  position: absolute; right: 1rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; stroke: #9a8070; pointer-events: none;
}

.field-error { font-size: 1.2rem; color: #dc2626; margin: 0; }

/* ── Search btn ── */
.search-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 1rem 2rem; width: 100%; justify-content: center;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.7rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.45rem; font-weight: 600;
  cursor: pointer; transition: all 0.2s;
}
.search-btn svg { width: 1.7rem; height: 1.7rem; }
.search-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.3); }

/* ── Section Divider ── */
.section-divider {
  display: flex; align-items: center; gap: 1rem;
  margin: 2rem 0; color: #9a8070; font-size: 1.3rem;
}
.section-divider::before, .section-divider::after {
  content: ''; flex: 1; height: 1px; background: #e5ddd5;
}

/* ── Alert msg ── */
.alert-msg {
  display: flex; align-items: center; gap: 0.8rem;
  background: #fff3e0; border: 1px solid #ffd180;
  border-radius: 0.7rem; padding: 1rem 1.4rem;
  font-size: 1.4rem; color: #e65100; margin-top: 1.5rem;
}
.alert-msg svg { width: 1.8rem; height: 1.8rem; flex-shrink: 0; }

/* ── Info Fields ── */
.info-field { display: flex; flex-direction: column; gap: 0.4rem; }
.info-label { font-size: 1.2rem; font-weight: 500; color: #9a8070; text-transform: uppercase; letter-spacing: 0.05em; }
.info-value { font-size: 1.5rem; font-weight: 600; color: #1c0f0a; }

/* ── Tables ── */
.table-wrapper { overflow-x: auto; border-radius: 0.8rem; border: 1px solid #e5ddd5; }
.data-table { width: 100%; border-collapse: collapse; font-size: 1.4rem; }
.data-table th {
  background: #f5f0ea; color: #4a3028; font-weight: 600;
  padding: 1.1rem 1.5rem; text-align: center; border-bottom: 2px solid #e5ddd5;
  white-space: nowrap;
}
.data-table td { padding: 1rem 1.5rem; text-align: center; border-bottom: 1px solid #f0ebe3; color: #2c1a10; }
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.quarter-label { text-align: left !important; font-weight: 500; }

.badge-paid   { background: #dcfce7; color: #15803d; padding: 0.25rem 0.9rem; border-radius: 99px; font-size: 1.2rem; font-weight: 600; }
.badge-unpaid { background: #fee2e2; color: #b91c1c; padding: 0.25rem 0.9rem; border-radius: 99px; font-size: 1.2rem; font-weight: 600; }

.row-reversal { background: #fff7ed; font-style: italic; color: #c2410c; }
.row-excess   { background: #eff6ff; color: #1d4ed8; }
.row-arrears  { background: #fef2f2; }
.row-balance  { background: #f0fdf4; }

/* ── Payment Layout ── */
.payment-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 2.4rem; }

.payment-desc-box {
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.9rem; overflow: hidden;
}
.desc-title {
  font-family: 'DM Serif Display', serif; font-size: 1.6rem;
  color: #1c0f0a; margin: 0; padding: 1.2rem 1.6rem;
  border-bottom: 1px solid #e5ddd5; background: #f0ebe3;
}
.desc-content { padding: 1.2rem 1.6rem; font-size: 1.35rem; line-height: 1.7; color: #4a3028; white-space: pre-line; }
.due-amount-box {
  display: flex; flex-direction: column; padding: 1.2rem 1.6rem;
  background: #7c2d12; border-top: none;
}
.due-label { font-size: 1.2rem; color: rgba(255,255,255,0.75); margin-bottom: 0.2rem; }
.due-value { font-size: 1.9rem; font-weight: 700; color: #fff; }

.payment-inputs { display: flex; flex-direction: column; gap: 1.6rem; }

.input-with-icon { display: flex; align-items: center; }
.input-prefix {
  background: #f0ebe3; border: 1.5px solid #ddd4ca; border-right: none;
  border-radius: 0.7rem 0 0 0.7rem; padding: 1rem 1.2rem;
  font-size: 1.4rem; font-weight: 600; color: #7c2d12; white-space: nowrap;
}
.input-prefix.fine    { color: #b91c1c; background: #fff5f5; border-color: #fecaca; }
.input-prefix.success { color: #15803d; background: #f0fdf4; border-color: #bbf7d0; }
.input-with-icon .field-input.prefixed { border-radius: 0 0.7rem 0.7rem 0; }
.fine-input    { border-color: #fecaca; }
.success-input { border-color: #bbf7d0; }

/* ── Form Actions ── */
.form-actions { display: flex; justify-content: flex-end; margin-top: 0.4rem; }
.continue-btn {
  display: inline-flex; align-items: center; gap: 0.8rem;
  padding: 1.2rem 3rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 600;
  cursor: pointer; box-shadow: 0 4px 14px rgba(124,45,18,0.3);
  transition: all 0.2s;
}
.continue-btn svg { width: 1.8rem; height: 1.8rem; }
.continue-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(124,45,18,0.4); }

/* ── Responsive ── */
@media (max-width: 1024px) { .four-col { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) {
  .assess-page { padding: 1.5rem 1.2rem 3rem; }
  .four-col, .two-col { grid-template-columns: 1fr; }
  .payment-layout { grid-template-columns: 1fr; }
  .page-title { font-size: 2rem; }
  .page-header { flex-direction: column; }
  .form-actions { justify-content: stretch; }
  .continue-btn { width: 100%; justify-content: center; }
}
</style>